<template>
  <div class="capusta-panel" @click="$emit('click')">
    <div class="capusta-panel-icon">
      <img :src="getIconUrl(icon)" :alt="icon" />
    </div>
    <div class="capusta-panel-description">
      {{ description }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'CapustaPanel',
  props: {
    icon: String,
    description: String,
  },
  methods: {
    getIconUrl(icon) {
      const images = require.context('@/assets/img/icons/', false, /\.svg$/);
      return images('./' + icon + '.svg');
    },
  },
};
</script>

<style lang="sass" scoped>
  .capusta-panel
    display: flex
    align-items: center
    padding: 20px
    border-radius: 5px
    cursor: pointer

    #{theme("eclipse")} &
      background-color: #fff
      box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15)

      &:hover,
      &.active
        box-shadow: 0px 4px 4px rgba(255, 107, 140, 0.15)

    #{theme("obsidian")} &
      background-color: #27283c
      box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15)

      &:hover,
      &.active
        background-color: #31334d
        box-shadow: 0px 4px 4px rgba(81, 22, 22, 0.15)

  .capusta-panel-icon
    width: 40px
    height: 40px
    flex: none
    display: flex
    justify-content: center
    align-items: center
    margin-right: 20px
    background: linear-gradient(0deg, #181722, #181722), rgba(255, 255, 255, 0.5)
    border-radius: 50%

  .capusta-panel-description
    font-weight: 600
    font-size: 16px
    line-height: 20px

    #{theme("eclipse")} &
      color: #212121

    #{theme("obsidian")} &
      color: #fff
</style>
